import SectionJobsSidebar1 from "../../sections/jobs/sidebar/section-jobs-sidebar1";
import SectionJobsList from "../../sections/jobs/section-jobs-list";
import { useEffect } from "react";
import { loadScript } from "../../../../../globals/constants";
import { addDoc, collection, query, where, getDocs, doc, getDoc, updateDoc, orderBy } from "firebase/firestore";
import { db, functions } from "../../../../../globals/firebase";
import { httpsCallable } from "firebase/functions";



function JobsListPage() {

  // const stripe = require('stripe')("sk_test_51LJREeEAgKftLEashc6yY0xUIEk66UL1FCnu5qveRlkFPE64L4BqVovSxqKSj4coGwgMmmHvGmlSxDtsz5ey9PmL00tG2dhETo");


  useEffect(() => {
    loadScript("js/custom.js")

    const user = localStorage.getItem("user")

    if (user === null || user === undefined) {
      window.location.href = "/"
    }

    GetStatus()

  }, [])

  const GetStatus = async () => {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get('session_id');

    if (sessionId != null) {
      // const session = await stripe.checkout.sessions.retrieve(sessionId);
      
      try {
        const verifyCheckoutSession = httpsCallable(functions, 'verifyCheckoutSession');
        const result = await verifyCheckoutSession({ sessionId });
        const session = result.data;

        const getpayment = query(collection(db, "wpm_payments"), where("sessionid", "==", session.id))
        const documentSnapshots = await getDocs(getpayment);
        if (documentSnapshots.docs.length < 1) {
          const myCollection = collection(db, 'wpm_payments');

          const userData = localStorage.getItem("user");
          if (!userData) {
            console.warn("User not found in localStorage");
            return;
          }
          
          const user = JSON.parse(userData);
          if (!user.userid) {
            console.warn("User ID not found in user data");
            return;
          }

          const userid = user.userid;

          await addDoc(myCollection, {
            userid: userid,
            sessionid: session.id,
            prompts: parseInt(session.metadata.prompts),
            images: parseInt(session.metadata.images),
            amount: session.amount_total,
            datainsert: Date.now()
          }).then(async () => {

            //update user credits
            const docRef = doc(db, "wpm_users", userid)
            const userdoc = await getDoc(docRef);
            // Set the "capital" field of the city 'DC'
            await updateDoc(docRef, {
              creditsprompts: userdoc.data().creditsprompts + parseInt(session.metadata.prompts),
              creditsimages: userdoc.data().creditsimages + parseInt(session.metadata.images),
            });

          })

        }
      } catch (error) {
        console.error("Error verifying checkout session:", error);
      }


    }
  }

  return (
    <>

      <div className="twm-home3-banner-section twm-bnr-hpage-13">
        <div className="container">
          <div className="row">
             <div className="sidebarleft col-xl-4 col-lg-4 col-md-12">
              <SectionJobsSidebar1 />
            </div>

            <div className="sidebarright col-xl-8 col-lg-8 col-md-12">
              <SectionJobsList />

            </div>

          </div>
        </div>
      </div>





    </>
  )
}

export default JobsListPage;
